// Cookie expiration constants
export const COOKIE_EXPIRATION = {
    ONE_MONTH: 1000 * 3600 * 24 * 30, // 30 days in milliseconds
    ONE_DAY: 1000 * 3600 * 24,        // 1 day in milliseconds
    ONE_HOUR: 1000 * 3600,            // 1 hour in milliseconds
}
